import { StatusCodes } from 'http-status-codes';

export const checkUnauthorizedError = (error: Error): boolean => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'statusCode' in error &&
    (error as { statusCode?: number }).statusCode === StatusCodes.UNAUTHORIZED
  ) {
    return true;
  }
  return false;
};
